import type { ScreenModule } from "../../../app/screen-module";
import { WorkOrderDetailPage } from "./Page";

export default {
	id: "end-user.work-order-detail",
	path: "/app/orders/:orderId",
	area: "end-user",
	label: "カード詳細",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: WorkOrderDetailPage,
} satisfies ScreenModule;
